import apiRequest from "../../utils/apiRequest";

/**
 * Service liste d'attente (modèle simplifié DEC-8). Fonctions async plates
 * au-dessus de {@code apiRequest} (même patron que les autres services).
 */

/** Ajoute un patient à la liste avec un médecin assigné. payload = { patientId, doctorId }. */
export const registerToQueue = (payload) => apiRequest.post(`/queue`, payload);

/** RDV du jour (flag « a un RDV aujourd'hui » de la page Patients). */
export const getTodayAppointments = () => apiRequest.get(`/queue/appointments-today`);

/** File du médecin connecté (FIFO). */
export const getDoctorQueue = () => apiRequest.get(`/queue/doctor/me`);

/** Prise en charge : retire le patient de la liste, renvoie { patientId }. */
export const takeCharge = (entryId) => apiRequest.post(`/queue/${entryId}/take-charge`);

/** Vue secrétaire : toute la liste d'attente du jour (FIFO, tous médecins). */
export const getTodayList = () => apiRequest.get(`/queue/today`);

/** Réassigne une entrée à un autre médecin (correction secrétaire). */
export const reassignDoctor = (entryId, doctorId) =>
  apiRequest.put(`/queue/${entryId}/doctor`, { doctorId });

/** Retire un patient de la liste (action secrétaire). */
export const removeFromQueue = (entryId) => apiRequest.del(`/queue/${entryId}`);
